
export default {
  name: 'ChangePassword',
  data () {
    return {
      theme: process.env.Theme,
      version: process.env.VersionApp,
      token: null,
      password: null,
      confirmation: null
    }
  },
  computed: {
    IsThemeSDS: function () {
      var result = false
      if (this.theme === 'SDS') {
        result = true
      }
      return result
    },
    IsThemeCOTEXO: function () {
      var result = false
      if (this.theme === 'COTEXO') {
        result = true
      }
      return result
    },
    classBgImg: function () {
      var result = 'bg-img-acelerauto'
      if (this.theme === 'SDS') {
        result = 'bg-img'
      } else if (this.theme === 'COTEXO') {
        result = 'bg-img-cotexo'
      }
      return result
    }
  },
  mounted () {
    this.token = this.$route.params.token
  }
}



// WEBPACK FOOTER //
// ./src/views/public/password/change/ChangePassword.js